(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name settings.controller:SettingsCtrl
   *
   * @description
   *
   */
  angular
    .module('settings')
    .controller('SettingsCtrl', SettingsCtrl);

  function SettingsCtrl($scope, $q, $rootScope, $translate, $uibModal, $state, userSettingsData, UserSettingsService, ValidationService, SettingsService, HelperService, AlertService, AccountsService, GoogleTagManagerHelperService) {

    var vm = this;

    vm.tempDompObj = {};

    vm.trrAccounts = [];
    vm.selectedTrrAccount = {};

    vm.inputOptions = {
      minLengthOld: -1,
      maxLength: -1,
      minLength: -1,
      checkForValidation: false
    };

    //vm.selectedTab = "account";

    vm.checkForValidation = function () {
      vm.inputOptions.checkForValidation = true;
    };
    vm.userBasedNotificationsList = [];
    vm.accountBasedNotificationsList = [];
    vm.loadSmsAndNotifications = loadSmsAndNotifications;
    init();

    function prepareNotificationListCRO() {
      vm.notificationsList = {};
      vm.notificationsList.originalList = angular.copy(userSettingsData.result[0].userNotificationDetailsList);
      var brojac = 0;
      _.forEach(vm.notificationsList.originalList, function (item) {
        item.tempId = brojac++;
      });
      vm.notificationsList.modifiedList = angular.copy(vm.notificationsList.originalList);
    }

    function init() {
      vm.model = {};
      vm.model.userSettings = {};
      vm.model.security = {};
      vm.model.security.transactionConfirmation = "0";
      vm.model.userSettingsEditInput = {};
      vm.regexPatterns = ValidationService.getRegexPatternsForValidation();

      var defaultData = $rootScope.APP_GLOBAL_SETTINGS.defaultData;
      vm.country = $rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation;
      vm.selectedTab = (vm.country === "hr" || vm.country === "sl") ? "account" : "security";

      if (defaultData.APILocation === 'bh') {
        vm.inputOptions.minLengthOld = 6;
        vm.inputOptions.minLength = 8;
        vm.inputOptions.maxLength = 15;
      }

      if (defaultData.APILocation === 'sl') {
        loadAccounts(); //includes loading SmsAndNotifiacions
        loadAdditionalTransactionInformation();
      }

      if (defaultData.APILocation === 'hr') {
        prepareNotificationListCRO();
      }


      loadData();


    }

    vm.selectTab = function (tab, translateLabel) {
      if (tab == vm.selectedTab) return;
      vm.selectedTab = tab;
      GoogleTagManagerHelperService.pushEvent('Settings', 'Tab', $translate.instant(translateLabel));
    }

    function loadAdditionalTransactionInformation() {
      SettingsService.getAdditionalTransactionConfirmation()
        .then(function (response) {
          vm.model.security.transactionConfirmation = response.result[0].id;
        })
        .catch(function (error) {
          HelperService.showMessage(error, 'error');
        });
    }

    function loadAccounts() {
      AccountsService.getPage({accountTypeGroup: 'CurrentAccount', isOwn: true, isParentAccount: true})
        .then(function (response) {
          vm.trrAccounts = _.filter(response.result, function (account) {
            return account.isOwn;
          });
          vm.trrAccounts = _.uniq(vm.trrAccounts, function (item) {
            return item.iban
          });
          vm.selectedTrrAccount = vm.trrAccounts[0];

          var unregister = $rootScope.$on('appLanguageChangedHeader', function (evt, data) {
            if (vm.selectedTab == "notifications") {
              loadSmsAndNotifications();
            }
          });
          $scope.$on('$destroy', function () {
            unregister();
          });

          loadSmsAndNotifications();
        })
        .catch(function (error) {
          HelperService.showMessage(error, 'error');
        });
    }

    function loadSmsAndNotifications() {

      if (!vm.selectedTrrAccount)
        return;

      SettingsService.getSmsAndNotifications({orderBy: 'subOrderId', accountId: vm.selectedTrrAccount.accountId})
        .then(function (response) {
          vm.userBasedNotificationsList = response.result;
          vm.accountBasedNotificationsList = _.remove(vm.userBasedNotificationsList, function (item) {
            return item.accountId;
          });
        })
        .catch(function (error) {
          HelperService.showMessage(error, 'error');
        });
    }

    vm.changeSettings = function (item, value, type, accountBased) {

      return $uibModal.open({
        templateUrl: 'settings/sms-and-notification-modal.tpl.html',
        size: 'lg',
        controller: 'SmsAndNotificationModalCtrl',
        controllerAs: 'smsAndNotificationModal',
        resolve: {
          object: {
            user: vm.model.userSettings,
            //orderItem: item,
            orderObject: item,
            type: type, //SMS or EMAIl
            value: value,
            accountBased: accountBased,
            account: vm.selectedTrrAccount
          }

        },
        backdrop: 'static'
      })
        .result
        .then(function (result) {
          loadSmsAndNotifications();
        });
    };


    function loadData() {
      $rootScope.APP_GLOBAL_SETTINGS.userSettings = userSettingsData.result[0];
      var userSettings = userSettingsData.result[0];
      userSettings.houseNumber = userSettings.address1.split(/[\s]+/).pop().trim();
      userSettings.street = userSettings.address1.replace(new RegExp(userSettings.houseNumber, 'g'), "").trim();
      userSettings.mailUserType = 1;
      vm.model.userSettings = userSettings;
    }

//gsmCountryCode, gsmOperator i gsm
//dayPhoneCountryCode, dayPhoneOperator  i dayPhone
    function prepareDataForUpdate(userSettings) {
      return {
        "email": vm.model.userSettingsEditInput.notificationEmail,
        "dataConfirmation": true,
        "mailUsername": userSettings.firstName + " " + userSettings.lastName,
        "mailStreet": vm.model.userSettingsEditInput.street,
        "mailHouseNumber": vm.model.userSettingsEditInput.houseNumber,
        "mailCity": vm.model.userSettingsEditInput.city,
        "mailPostalCode": vm.model.userSettingsEditInput.postalCode,
        "mailUserType": vm.model.userSettingsEditInput.mailUserType,
        "gsmCountryCode": vm.model.userSettingsEditInput.gsmCountryCode,
        "gsmOperator": vm.model.userSettingsEditInput.gsmOperator,
        "gsm": vm.model.userSettingsEditInput.gsm,
        "dayPhoneCountryCode": vm.model.userSettingsEditInput.dayPhoneCountryCode,
        "dayPhoneOperator": vm.model.userSettingsEditInput.dayPhoneOperator,
        "dayPhone": vm.model.userSettingsEditInput.dayPhone
      };
    }

    vm.confirmUserSettingsEdit = function () {
      vm.editUserSettingsActive = false;
      var updateData = prepareDataForUpdate(vm.model.userSettingsEditInput);
      UserSettingsService.updateUserInfoOrders(updateData)
        .then(function (response) {
          GoogleTagManagerHelperService.pushEvent('Settings', 'Settings updated', 'Settings updated successfully!');
          console.log(response);
          if (response) {
            loadData();
          } else {
            vm.model.userSettings = angular.copy(vm.model.userSettingsEditInput);
          }

        }, function (error) {
          vm.editUserSettingsActive = true;
        });
    };

    vm.editUserSettings = function () {
      vm.editUserSettingsActive = true;
      vm.model.userSettingsEditInput = angular.copy(vm.model.userSettings);
    };

    vm.editUserEmail = function () {
      vm.editEmail = true;
      vm.model.userSettingsEditInput.notificationEmail = angular.copy(vm.model.userSettings.notificationEmail);
    }

    vm.confirmUserEmailChange = function () {
      vm.editEmail = false;
      var updateData = prepareDataForUpdate(vm.model.userSettingsEditInput);
      UserSettingsService.updateUserInfoOrders(updateData)
        .then(function (response) {
          if (response) {
            loadData();
          } else {
            vm.model.userSettings = angular.copy(vm.model.userSettingsEditInput);
          }
          vm.model.userSettings.notificationEmail = angular.copy(vm.model.userSettingsEditInput.notificationEmail);
        }, function (error) {
          vm.editEmail = true;
        });
    };


    vm.cancelUserSettingsEdit = function () {
      vm.editUserSettingsActive = false;
      vm.model.userSettingsEditInput = {};
    };

    vm.compareNewPassword = function () {
      console.log(vm.securityForm);
      if (vm.model.security.newPassword === vm.model.security.confirmNewPassword) {
        vm.securityForm.confirmNewPassword.$setValidity("incorrect", true);
        console.log(vm.securityForm.confirmNewPassword.$valid);
      } else {
        vm.securityForm.confirmNewPassword.$setValidity("incorrect", false);
        console.log(vm.securityForm.confirmNewPassword.$valid);
      }
    };

    var createDompObj = function () {
      return {
        oldPassword: vm.model.security.oldPassword,
        newPassword: vm.model.security.newPassword,
        confirmedNewPassword: vm.model.security.confirmNewPassword
      };
    };

    var clearForm = function () {
      vm.model.security.oldPassword = '';
      vm.model.security.newPassword = '';
      vm.model.security.confirmNewPassword = '';
    };

    vm.change = function () {

      var temp = {};
      temp.email = vm.model.security.email || null;
      temp.mothersLastName = vm.model.security.mothersLastName || null;
      if (temp.email || temp.mothersLastName) {
        UserSettingsService.updateInvoiceEmail(temp, vm.model.userSettings.id)
          .then(function (response) {
            GoogleTagManagerHelperService.pushEvent('Settings', 'Settings updated', 'Settings updated successfully');
            vm.model.userSettings = response;
            clearForm();
            var translatedSuccessMessage = $translate.instant('core.additionalDataChangedMsg');
            HelperService.showTranslatedMessage('success', translatedSuccessMessage, '', 3000, true, 2);
          })
          .catch(function (error) {
            HelperService.showTranslatedMessage('error', error.resultList[0].description, error.resultList[0].key);
          })
          .finally(function () {
          });
      }

      if (vm.securityForm.$valid) {
        var dompObj = createDompObj();
        SettingsService.changePassword(dompObj)
          .then(function (response) {
            var translatedSuccessMessage = $translate.instant('core.passwordChangedMsg');
            HelperService.showTranslatedMessage('success', translatedSuccessMessage, '', 3000, true, 2);
            GoogleTagManagerHelperService.pushEvent('Settings', 'Settings updated', 'Settings updated successfully!');
            if (vm.country === 'sr')
              navigateToDashboard();
          })
          .catch(function (error) {
            //$log.error(error);
            HelperService.showTranslatedMessage('error', error.resultList[0].description, error.resultList[0].key);

          })
          .finally(function () {
            clearForm();
          });
      }
    };

    vm.securityEditConfirm = function () {
      if (vm.confirmButtonPressed) return;
      // DO POST
      vm.confirmButtonPressed = true;
      SettingsService.changeAdditionalTransactionConfirmation({
        id: vm.model.security.transactionConfirmation,
        parameter: vm.model.security.transactionConfirmation == 0 ? 'OTP' : 'SMS'
      })
        .then(function (response) {
          $rootScope.APP_GLOBAL_SETTINGS.userSettings.additionalTransactionConfirmation = response;
          vm.securityEditActive = false;
        })
        .catch(function (error) {
          HelperService.showMessage(error, 'error');
        }).finally(function () {
        vm.confirmButtonPressed = false;
      });
    };


    vm.securitySetBlockade = function () {
      $state.go("blockade");
    };

    var navigateToDashboard = function () {
      $state.go('dashboard');
    };

    vm.setMobilePhoneNumber = function (phone) {
      if (!phone) {
        AlertService.infoAlert({
          text: 'settings.noNumber'
        });
        return;
      }

      $state.go("settings.gsmSettings");
    };

    function updateSettings(id, updateData) {
      return UserSettingsService.updateUserSettings(id, updateData)
        .then(function (response) {
          //todo
        }, function (error) {
          HelperService.showMessage(error, 'error');
          //refresh list to initial list
          prepareNotificationListCRO();
        });
    }
    function insertSettings(insertData) {
      return UserSettingsService.insertUserSettings(insertData)
        .then(function (response) {
          //todo
        }, function (error) {
          HelperService.showMessage(error, 'error');
          //refresh list to initial list
          prepareNotificationListCRO();
        });
    }

    vm.updateUserSettings = function () {
      var promises = [];

      var userNotificationListForPUT = getLists().putList;

      if (userNotificationListForPUT.length > 0) {
        var updateData = {
          userNotificationList: userNotificationListForPUT
        };
        promises.push(updateSettings(userSettingsData.result[0].id, updateData));
      }

      var userNotificationListForPOST = getLists().postList;
      if(userNotificationListForPOST.length > 0){
        var insertData = {
          userNotificationList: userNotificationListForPOST
        };
       promises.push(insertSettings(insertData));
      }

      $q.all(promises)
        .then(function (responses) {
          //
        })
    };

    vm.updateNotificationItem = function (item, type) {
      if (type === 'sms') {
        if (item.isEmail === true && item.isActive === true)
          item.isEmail = false;
      }
      if (type === 'email') {
        if (item.isEmail === true && item.isActive === true)
          item.isActive = false;
      }
    };

    function getLists() {
      _.sortBy(vm.notificationsList.modifiedList, ['tempId']);
      _.sortBy(vm.notificationsList.originalList, ['tempId']);

      var tempPUTList = [];
      var tempPOSTList = [];

      for (var i = 0; i < vm.notificationsList.originalList.length; i++) {
        if(!vm.notificationsList.originalList[i].userConfigId){
          var item = vm.notificationsList.modifiedList[i];
          var tempItem = {
            accountId: item.accountId || null,
            userConfigId: item.userConfigId,
            isActive: item.isActive || false,
            isEmail: item.isEmail || false,
            notificationType: item.notificationType
          };
          tempPOSTList.push(tempItem);

          continue;
        }

        if (vm.notificationsList.originalList[i].isActive !== vm.notificationsList.modifiedList[i].isActive ||
          vm.notificationsList.originalList[i].isEmail !== vm.notificationsList.modifiedList[i].isEmail) {
          var item = vm.notificationsList.modifiedList[i];
          var tempItem = {
            accountId: item.accountId,
            userConfigId: item.userConfigId,
            isActive: item.isActive || false,
            isEmail: item.isEmail || false,
            notificationType: item.notificationType
          };
          tempPUTList.push(tempItem);
        }
      }

      return {putList: tempPUTList, postList: tempPOSTList};
    }

    vm.updateUserMobileSetting = function () {
      AlertService.updateMobileSetting()
        .then(function (result) {
          if(result){
            UserSettingsService.updateUserMobileSetting(false)
              .then(function (response) {
                  vm.model.userSettings.mobileBankEnabled = response.mobileBankEnabled;
                  // HelperService.showTranslatedMessage('success', 'message','',3000);
                }, function (error) {
                  HelperService.showMessage(error, 'error');
                }
              );
          }
        }, function (error) {

        });


    }

  }
}());
